/**
 * Toont assistent-antwoorden zonder zichtbare markdown (*, **).
 */
export function formatAssistantDisplayText(raw: string): string {
  let s = raw.replace(/\r\n/g, '\n');
  // **vet** → vet
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  // Markdown-bullets aan begin van regel → •
  s = s.replace(/^\s*[\*\-]\s+/gm, '• ');
  s = s.replace(/^\s*\*\s+/gm, '');
  return s.trimEnd();
}
